import React from 'react';
import {LandingSiteThanksContent} from '@integraciones_doc24/wehealthy-api/types/landing';
import {Row, Col, Card, CardBody} from 'reactstrap';
import {connect} from 'react-redux';
import QRCode from 'react-qr-code';

interface propiedades {
  content: LandingSiteThanksContent;
  dynamicLink: string;
}

interface configObject {
  configReducer: {
    dynamicLink: string;
  };
}

const Thanks = (props: propiedades) => {

  const {content, dynamicLink} = props;

  return (
    <Row>
      <Col md={{size: 8, offset: 2}}>
        <Card className="border-color-primary mb-2 text-center">
          <CardBody>
            <h1>{content.title}</h1>
            <h2>{content.subTitle}</h2>
            <QRCode value={dynamicLink} size={250} />
            <p className="mt-5">{content.text}</p>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    dynamicLink: state.configReducer.dynamicLink,
  };
};

export default connect(mapStateToProps)(Thanks);
